import ScheduledMessagesAPI from '../../api/scheduledMessages';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getScheduledMessages(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, conversationId) {
    commit('setFetching', true);
    try {
      const response = await ScheduledMessagesAPI.get(conversationId);
      commit('setRecords', response.data);
    } catch (error) {
      // Handle error
    } finally {
      commit('setFetching', false);
    }
  },

  async create({ commit }, params) {
    commit('setCreating', true);
    try {
      await ScheduledMessagesAPI.create(params);
    } catch (error) {
      // Handle error
      throw error;
    } finally {
      commit('setCreating', false);
    }
  },

  async update({ commit }, { id, ...params }) {
    commit('setUpdating', true);
    try {
      await ScheduledMessagesAPI.update(id, params);
    } catch (error) {
      // Handle error
      throw error;
    } finally {
      commit('setUpdating', false);
    }
  },

  async delete({ commit }, { id }) {
    commit('setDeleting', true);
    try {
      await ScheduledMessagesAPI.delete(id);
      commit('deleteRecord', id);
    } catch (error) {
      // Handle error
      throw error;
    } finally {
      commit('setDeleting', false);
    }
  },

  async cancel({ commit }, { id }) {
    commit('setUpdating', true);
    try {
      const response = await ScheduledMessagesAPI.cancel(id);
      commit('updateRecord', response.data);
    } catch (error) {
      // Handle error
      throw error;
    } finally {
      commit('setUpdating', false);
    }
  },
};

export const mutations = {
  setRecords(_state, data) {
    _state.records = data;
  },
  updateRecord(_state, data) {
    const index = _state.records.findIndex(record => record.id === data.id);
    if (index !== -1) {
      _state.records.splice(index, 1, data);
    }
  },
  deleteRecord(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
  setFetching(_state, value) {
    _state.uiFlags.isFetching = value;
  },
  setCreating(_state, value) {
    _state.uiFlags.isCreating = value;
  },
  setUpdating(_state, value) {
    _state.uiFlags.isUpdating = value;
  },
  setDeleting(_state, value) {
    _state.uiFlags.isDeleting = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};